module.exports = __webpack_public_path__ + "img/img05e.78825757.png";